import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

// Versão do arquivo do shadcn SEM next-themes: o produto é claro, ponto.
// Manter a dependência só para ler um tema que nunca muda era peso morto.
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--r-cartao)',
          // O aviso sai do fluxo do documento: aqui a sombra não decora, ela
          // diz "isto está por cima". É o único caso em que o sistema usa uma.
          boxShadow: 'var(--sombra-2)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
